// The One Piece cast the quizzes draw from.
//
// This replaces the runtime call to api.jikan.moe. That call returned HTTP 200
// with {"status":500,"type":"UpstreamException"} whenever MyAnimeList was slow,
// so `data` was undefined, the cast came back empty, and the game started with
// no picture and four blank answer buttons. Confirmed happening in production on
// 2026-07-26. The list is now baked in at build time by
// scripts/fetch-characters.js — no request, no rate limit, nothing to time out.
//
// Images are still MyAnimeList CDN URLs. We store links, not files.

import onePieceCharacters from './onePieceCharacters';

// MyAnimeList files the Marines and a few others under their real names, while
// the rest of this codebase — devilFruitGameConfig especially — uses the names
// people actually say. Without this, the Devil Fruit quiz silently lost every
// one of these characters.
const PREFERRED_NAME = {
  'Marshall D. Teach': 'Blackbeard',
  Sakazuki: 'Akainu',
  Borsalino: 'Kizaru',
  Kuzan: 'Aokiji',
  'Clown Caesar': 'Caesar Clown',
};

// How many characters the guessing games may ask about, most recognisable first.
// The full cast is 1452 people, the overwhelming majority of whom are one-scene
// villagers ("Homing's Wife", "Horseman", "Hotori"). Asking players to name
// those is not difficulty, it is noise.
export const QUIZ_CAST_SIZE = 300;

const withPreferredNames = onePieceCharacters.map((c) =>
  PREFERRED_NAME[c.name] ? { ...c, name: PREFERRED_NAME[c.name] } : c
);

/** The whole cast, most recognisable first. */
export const fullCast = withPreferredNames;

/**
 * Cast shaped exactly like a Jikan /anime/{id}/characters response entry, so the
 * quiz views can drop it straight in where the fetch result used to go.
 */
export const getCast = (limit = QUIZ_CAST_SIZE) =>
  withPreferredNames.slice(0, limit).map((c) => ({
    role: c.role,
    favorites: c.favorites,
    character: {
      mal_id: c.id,
      name: c.name,
      images: { jpg: { image_url: c.image } },
    },
  }));

export default getCast;
